/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from 'react';
import { Button, Form, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import axios from 'axios';
import DatePicker from "react-datepicker";
import moment from 'moment';

// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { adminReport, locationlist } from 'shared/settings/apiconfig';
import Datatable from 'shared/datatable';
import { ArrayValueReorder } from 'shared/modifiers';

// style imports
import "react-datepicker/dist/react-datepicker.css";
import './Admin.scss';
import { NoData } from 'features/components/redirect/NoData';
/**
 * this page is used to show sale item report in table
 * 
 * @param props
 * 
 * @return  sales list html code
 * 
**/

export default class AdminReport extends Component {
    initialSearchState;
    search;
    startDatePicker;
    endDatePicker;
    config;
    id;
    filterSearch;
    constructor(props) {
        super(props);

        this.dataTable = createRef();

        /* initial search state */
        this.initialSearchState = {
            starttime:{ field: 'fromdate', value: '', op: '>=', join: 'AND'},
            endtime: { field: 'todate', value: '', op: '<=', join: 'AND' },
            locationid: { field: 'locationid', value: '', op: '=', join: 'AND' },
        }
        this.state = {
            search: this.initialSearchState,
            searchData: false,
            modal: false,
            tableData: [],
            salesDetails: {},
            category: [],
            sales: [],
            issearch: false,
            saleid: { value: '', valid: false, error: '' },
            locations: [],
            isdisabled: false,
            location: '',
            locationlength:0,
            isActiveCheckbox : "",
            isDateFromCheckBox: "",
            DateCheckBoXValue: '',
            currentDate : '',
            SearchButton : false,
            locationAllSelected: false,
            errorpageredirect: false,
            errorType: '',
            errorMessage: ''
        }

        this.config = {
            name: 'admin report',
            url: adminReport,
            isReport: true,
            params: {},
            columns: [

                // Total Users and Total New Registrations to be shown only for admin app
                // { name: 'Total Users', property: 'totalUserCount', sort: false, width: '200px',columnType: 'custom', customColumn: this.totalUserCount, toolTip: true, toolTipText: 'Total Users : All registered users to date' },
                // { name: 'Total New Registrations', property: 'newUserRegistrations', sort: false, width: '200px',columnType: 'custom', customColumn: this.newUserRegistrations, toolTip: true, toolTipText: 'Total New Registrations : The number of new registrations for the period selected'  },
                { name: 'Total Sales Closed', property: 'totalSalesClosed', sort: false, width: '200px', columnType: 'custom', customColumn: this.totalSalesClosed, toolTip: true, toolTipText: 'Total Sales Closed : The total sales closed for the time period selected' },
                { name: 'Total Items Sold', property: 'totalItemsSold', sort: false, width: '200px', columnType: 'custom', customColumn: this.totalItemsSold, toolTip: true, toolTipText: 'Total Items Sold : The total items sold for the time period selected' },
                { name: 'Total Items Not Sold', property: 'totalItemsNotSold', sort: false, width: '200px',columnType: 'custom', customColumn: this.totalItemsNotSold, toolTip: true, toolTipText: 'Total Items Not Sold : The total items not sold for the time period selected' },
                { name: 'Total Items', sort: false, width: '150px',columnType: 'custom', customColumn: this.customTotalItems, toolTip: true, toolTipText: 'Total Items : The total of sold items + not sold items' },
                { name: 'Percentage of Items Sold', sort: false, width: '150px',columnType: 'custom', customColumn: this.customTotalpercentage, toolTip: true, toolTipText: 'Percentage of Items Sold : Total Items Sold / Total Items * 100'},
                { name: 'Average Sale Price', property: 'avgSalePrice', sort: false, width: '200px', columnType: 'custom', customColumn: (row) => { if ('avgSalePrice' in row && row.avgSalePrice !== null) {return (`$${parseFloat(row.avgSalePrice).toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","))} else {return 0} }, toolTip: true , toolTipText: "Average Sale Price : The total sale price + buyer's premium / by the total sales closed for the time period selected"  },
                { name: 'Average Item Price', property: 'avgItemPrice', sort: false, width: '200px', columnType: 'custom', customColumn: (row) => { if ('avgItemPrice' in row && row.avgItemPrice !== null) {return (`$${parseFloat(row.avgItemPrice).toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","))} else {return 0} },  toolTip: true , toolTipText: "Average Item Price : The total sale price + buyer's premium / by the total items sold for the time period selected"  },
                { name: "Total Buyer's Premium", property: 'totalBuyersPremium', sort: false, width: '200px', columnType: 'custom', customColumn: (row) => { if ('totalBuyersPremium' in row && row.totalBuyersPremium !== null) {return (`$${parseFloat(row.totalBuyersPremium).toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","))} else {return 0} }, toolTip: true, toolTipText: "Total Buyer's Premium : The total buyer's premium for the time period selected"  },
                { name: "Total Item Tax", property: 'totalItemTax',sort: false, width: '200px', columnType: 'custom', customColumn: (row) => { if ('totalItemTax' in row && row.totalTaxOnBuyerPremium !== null) {return (`$${parseFloat(row.totalItemTax).toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","))} else {return 0} }, toolTip: true, toolTipText: "Total Item Tax : The total tax on sold items for the time period selected" },
                { name: 'Total Item Tax + Total BP Tax', property: 'totalTax', sort: false, width: '250px', columnType: 'custom', customColumn: (row) => { if ('totalTax' in row && row.totalTax !== null) {return (`$${parseFloat(row.totalTax).toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","))} else {return 0} }, toolTip: true, toolTipText: "Total Item Tax + Total BP Tax : The total tax on sold items + total tax on buyer's premium for the time period selected"  },
                { name: 'Total Sale Price', property: 'totalSalePrice', sort: false, width: '200px', columnType: 'custom', customColumn: (row) => { if ('totalSalePrice' in row && row.totalSalePrice !== null) {return (`$${parseFloat(row.totalSalePrice).toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","))} else {return 0} }, toolTip: true, toolTipText: 'Total Sale Price : The total sale price of all sold items for the time period selected' },
                { name: "Total Sale Price + Buyer's Premium", property: 'totalAmount', sort: false, width: '200px', columnType: 'custom', customColumn: (row) => { if ('totalAmount' in row && row.totalAmount !== null) {return (`$${parseFloat(row.totalAmount).toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","))} else {return 0} }, toolTip: true, toolTipText: "Total Sale Price + Buyer's Premium : The total sale price + buyer's premium for the time period selected" },
                {
                    name: '', property: 'id', columnType: 'actions', actions: [], customHeader: "CSV", width: '200px',
                }
            ],
            // sort: [],
            pagination: true,
            field: ["totalItems","totalSalesClosed", "totalItemsSold", "totalItemsNotSold", "avgItemPrice", "avgSalePrice", "totalSalePrice","totalAmount","totalBuyersPremium", "totalTax", "location"],
            filename: "admin-report",
            // defaultFilter: [{ field: 'salestatus', value: 'Closed', op: '=', join: 'AND' }],
            csvColumn: [
            ]    

        };
        this.search = {};
        this.startDatePicker = false;
        this.endDatePicker = false;
        this.id = null;
        this.locations = [];

    }

    componentDidMount = () => {
        this.getLocationList();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }

    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }
    
    customTotalItems = (value) => {
        const res = value.totalItemsSold + value.totalItemsNotSold
        return res;
    }

    customTotalpercentage = (value) => {

        const result = value.totalItemsSold + value.totalItemsNotSold;
        const res = value.totalItemsSold / result * 100;
        return res ? `${parseFloat(res).toFixed(1)}%` : '0%';
        
    }

    // Total items not sold custom column
    totalItemsNotSold = (value) => {
        const res = value.totalItemsNotSold
        return res
    }
    // Total items sold custom column
    totalItemsSold = (value) => {
        const res = value.totalItemsSold 
        return res
    }
    // Total SalesClosed custom column
    totalSalesClosed = (value) => {
        const res = value.totalSalesClosed
        return res
    }
    // Total totalUserCount custom column
    totalUserCount = (value) => {
        const res = value.totalUserCount
        return res
    }
    // Total newUserRegistrations custom column
    newUserRegistrations = (value) => {
        const res = value.newUserRegistrations
        return res
    }

    setEndDate() {
        let end_date = moment().subtract(1, "days").endOf('day').format("YYYY-MM-DD HH:mm:ss");
        this.setState({
            errorMessage: '',
            currentDate : end_date
        },()=>{
            this.searchEnable()
        })
    }
    
    onChangeCheckBox = (event,date) => {
        if(event === this.state.isActiveCheckbox){
            this.setState({
                isActiveCheckbox: '',
                isDateFromCheckBox: false,
                DateCheckBoXValue: '',
            })
        }
        else{
            this.setState({
                isActiveCheckbox: event,
                isDateFromCheckBox: true,
                DateCheckBoXValue: date,
            },()=>{
                this.setState({
                    ...this.state,
                    issearch: true,
                    search: {
                        ...this.state.search,
                        starttime: {
                            ...this.state.search['starttime'],
                            value: ''
                        },
                        endtime: {
                            ...this.state.search['endtime'],
                            value: ''
                        },
                      /*   ['starttime']: {
                            ...this.state.search['starttime'],
                            value: ''
                        },
                        ['endtime']: {
                            ...this.state.search['endtime'],
                            value: ''
                        }, */
                    }
                })
            })  
        }
        this.setEndDate() 
    }

    // Enable search button according to required fields
    searchEnable() {
        let { locationAllSelected } = this.state
        if(Boolean(this.state.search.locationid.value) || locationAllSelected) {
            if(this.state.DateCheckBoXValue && this.state.currentDate) {
                this.setState({
                    SearchButton: true
                })
            }
            else if(this.state.search.starttime.value && this.state.search.endtime.value) {
                this.setState({
                    SearchButton: true
                })
            } 
            else{
                this.setState({
                    SearchButton: false
                })
            }  
        }
        else {
            this.setState({
                SearchButton: false
            })
        }
    }

    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        if(event.target.value==='all'){
            this.setState({
                ...this.state,
                issearch: true,
                isdisabled: true,
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: eventValue
                    }
                }
            })
        }
        if(event.target.name === 'locationid'){
        this.setState({
            ...this.state,
            issearch: true,
            isdisabled: true,
            search: {
                ...this.state.search,
                [event.target.name]: {
                    ...this.state.search[event.target.name],
                    value: Number(eventValue)
                }
            }
        }, () => {
            if(event.target.value === 'All') {
                this.setState({
                    locationAllSelected: true
                },()=>{
                    this.searchEnable()
                }) 
            }
            else{
                this.setState({
                    locationAllSelected: false
                },()=>{
                    this.searchEnable()
                })
            }
            if(event.target.value === '')
            this.checkSearch();                
        });}
        else{
            this.setState({
                ...this.state,
                issearch: true,
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: eventValue
                    }
                }
            }, () => {
                if (event.target.value === '')
                    this.checkSearch();
            });
        }
    }

    /* called when clear all in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            errorMessage: '',
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
            isdisabled: false,
            isActiveCheckbox: '',
            isDateFromCheckBox: false,
            DateCheckBoXValue: '',
            currentDate: '',
            locationAllSelected: false,
            SearchButton: false
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    // handle enter key search
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.enableSearch()
        }
    }

    /* called when search button clicked */
    enableSearch = () => {
        var search = {
            starttime: { ...this.state.search.starttime, value: this.state.isDateFromCheckBox ? this.state.DateCheckBoXValue : this.state.search.starttime.value ? moment(new Date(this.state.search.starttime.value)).startOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            endtime: { ...this.state.search.endtime, value: this.state.isDateFromCheckBox ? this.state.currentDate : this.state.search.endtime.value ? moment(new Date(this.state.search.endtime.value)).endOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            locationid: { ...this.state.search.locationid, },
        }
        this.setState({
            filterSearch: search,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* check enable search and clear all */
    checkSearch = () => {
        let isenable = false;
        let issearchData = this.state.searchData;
        for (let control of Object.keys(this.state.search)) {
            if (this.state.search[control].value) {
                isenable = true;
                break;
            }
        }
        this.setState({
            ...this.state,
            search: isenable ? this.state.search : this.initialSearchState,
            searchData: isenable ? this.state.searchData : false,
            issearch: isenable
        }, () => {
            if (!isenable && issearchData)
                this.dataTable.current.searchData();
        });
    }

    /* called when accordion clicked */
    accordionValue = (tr) => {
        let row = JSON.stringify(tr);
        row = row.replace(/""/g, '"- - - "').replace(/null/g, '"- - - "')
        row = JSON.parse(row)
        return (
            <div className="accordion-view" style={{ padding: "1% 1%" }}>
                {row && Object.keys(row).length ?
                    <div className="d-flex">
                        <div>
                            {"area" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Area</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["area"]}</div>
                            </div>}
                            {"invoicenumber" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Invoice</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["invoicenumber"] != null ? "Created" : "Not Created"}</div>
                            </div>}
                            {"bidcount" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Number of Bids</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["bidcount"]}</div>
                            </div>}
                            {"viewcount" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Number of Views</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["viewcount"]}</div>
                            </div>}
                            {"soldamount" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Sold Amount $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">:{row["soldamount"]}</div>
                            </div>}
                            {"tax" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Tax $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["tax"]}</div>
                            </div>}
                        </div>
                        <div>
                            {"goal" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Goal $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["goal"]}</div>
                            </div>}
                            {"value" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Value $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["value"]}</div>
                            </div>}
                            {"handling" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Handling $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["handling"]}</div>
                            </div>}
                            {"shipping" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Shipping $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["shipping"]}</div>
                            </div>}
                            {"buyerspremium" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyers Premium $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["buyerspremium"]}</div>
                            </div>}
                            {"saleprice" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Final Sale Price $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["saleprice"]}</div>
                            </div>}
                        </div>
                        <div style={{ marginLeft: "-27px", paddingRight: "60px" }}>
                            {"directbuy" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Direct Buy $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["directbuy"]}</div>
                            </div>}
                            {"starttime" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Item Start Date</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{tr !== "" && moment(row['starttime']).format('MM/DD/YYYY hh:mm A')} {moment.tz(row['timezone']).zoneAbbr()}</div>
                            </div>}
                            {"endtime" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Item Close Date</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{tr !== "" && moment(row['endtime']).format('MM/DD/YYYY hh:mm A')} {moment.tz(row['timezone']).zoneAbbr()} </div>
                            </div>}
                            {"firstname" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer First Name</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["firstname"]}</div>
                            </div>}
                            {"lastname" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer Last Name</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["lastname"]}</div>
                            </div>}
                            {"nickname" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer User Name</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["nickname"]}</div>
                            </div>}
                        </div>
                        <div>
                            {"email" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer Email</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-21px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["email"]}</div>
                            </div>}
                            {"mobilenumber" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer Phone</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-21px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["mobilenumber"]}</div>
                            </div>}
                            {"address1" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer Address</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-21px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["address1"]}</div>
                            </div>}
                        </div>

                    </div>
                    : ''}
            </div>
        );
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }

    /* set date for date input change */
    setDate = (control, date) => {
        const { search } = this.state;
        let errorMessage = '';
    
        const updatedSearch = {
            ...search,
            [control]: {
                ...search[control],
                value: date
            }
        };
    
        const { starttime, endtime } = updatedSearch;
    
        if (starttime.value && endtime.value) {
            const start = new Date(starttime.value);
            const end = new Date(endtime.value);
    
            if (end < start) {
                errorMessage = "Please select a date range within any 12 month period";
                updatedSearch.endtime.value = null; 
            } else {
                const monthsDiff =
                    (end.getFullYear() - start.getFullYear()) * 12 +
                    (end.getMonth() - start.getMonth());
    
                if (monthsDiff > 12 || (monthsDiff === 12 && end.getDate() > start.getDate())) {
                    errorMessage = "Please select a date range within any 12 month period";
                }
            }
        }
    
            this.setState({
                issearch: true,
                isActiveCheckbox: '',
                isDateFromCheckBox: false,
                DateCheckBoXValue: '',
                currentDate: "",
                errorMessage,
                search: updatedSearch
            }, () => {
                this.searchEnable();
        });
    }  
    

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }


    /* Get Location list */
    getLocationList = async () => {
        await axios.all([
            axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
        ])
           .then(response => {
                this.locations = response[0].data.data;
                if(this.locations.length == '1'){                
                        this.setState({
                            ...this.state,
                            locations: ArrayValueReorder(response[0].data.data, 'title'),
                            location: this.locations[0].title,
                            locationlength:this.locations.length,
                            isdisabled:true,
                            search: {
                                ...this.state.search,
                                locationid: {
                                    ...this.state.search.locationid,
                                    value: this.locations[0].id
                                },
                            }
                        });
                }
                else{
                        this.setState({
                            ...this.state,
                            locations: ArrayValueReorder(response[0].data.data, 'title'),
                            location: this.locations[0].title,
                            locationlength:this.locations.length,
                        })
                }
            })
            .catch(error => {
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });
    }
    render() {
        if (this.state.errorpageredirect) {
            return <NoData {...this.props} type={this.state.errorType} />
        }
        let date = new Date()
        let Yesterday = moment().subtract(1, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let Year = moment().startOf('year').startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let Month = moment().startOf('month').startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let Week = moment(date).format('dddd') === 'Monday' ? moment().subtract(7, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss") : moment().startOf('isoWeek').startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let last_7days = moment().subtract(7, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let last_30days = moment().subtract(30, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let last_365days = moment().subtract(365, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss");
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }} id="sale-hostory-report">
                <div className="sale-search">
                    <div className="sales-list-search">
                        <Form className="sales-list-font">
                            <div className="sales-search-container">
                                <Row>
                                <Col>
                                    <label>Location *</label>
                                        <Form.Control as="select" name="locationid" value={this.state.search.locationid.value} onKeyDown={this._handleKeyDown} onChange={(event) => this.searchInputChange(event)}>
                                           <option value="" disabled>Please select location</option>
                                           {/* {this.state.locationlength>1?<option value="All">All</option>:''} */}
                                            {this.state.locations.map((loc, index) =>
                                                <option key={index} value={loc.id}>{loc.title}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Sale End Date From{!this.state.isActiveCheckbox ? "*" : ""}</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.start.state.open && e.preventDefault()}>
                                                <DatePicker ref={r => this.start = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.starttime.value} selected={this.state.search.starttime.value} onChange={date => { this.setDate('starttime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <label>Sale End Date To{!this.state.isActiveCheckbox ? "*" : ""}</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.end.state.open && e.preventDefault()}>
                                                <DatePicker minDate={this.state.search.starttime.value ? this.state.search.starttime.value : ''} ref={r => this.end = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.endtime.value} selected={this.state.search.endtime.value} onChange={date => { this.setDate('endtime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>   
                                    <Col>
                                        <div className="mt-3">
                                            <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                            <Button variant="seller-search" disabled={!this.state.SearchButton || this.state.errorMessage } onClick={() => this.enableSearch()}>Search</Button>
                                        </div>
                                    </Col>                      
                                </Row>
                                <Row style={{ width: '70%'}}>
                                    <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px' }}>
                                                 <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'yesterday'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('yesterday',Yesterday)}></div>
                                             </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                 <div>Yesterday</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Yesterday'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px'}}>
                                               <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'week' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('week',Week)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>Week to Date</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Monday to today of current week'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px'}}>
                                                <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'month'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('month',Month)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                 <div>Month to Date</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'First day of the current month to current date'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px'}}>
                                               <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'year'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('year',Year)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                 <div>Year to Date</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'First day of the current year to current date'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                </Row>
                                <Row style={{ width: '70%'}}>
                                    <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px' }}>
                                                <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'last_7days'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('last_7days',last_7days)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>Last 7 days</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Past 7 days excluding current date'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px'}}>
                                              <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'last_30days'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('last_30days',last_30days)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>Last 30 days</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Past 30 days excluding current date'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px'}}>
                                                <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'last_365days'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('last_365days',last_365days)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>Last 365 days</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Past 365 days excluding current date'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                   </Col>
                                </Row>
                                {this.state.errorMessage && (
                                    <div className="text-danger text-center" style={{fontSize: '14px'}}>
                                        {this.state.errorMessage}
                                    </div>
                                )}

                            </div>
                        </Form>

                    </div>
                </div>
                <div className="sale-list">
                    <Datatable config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} onDataUpdate={this.updateTableData}></Datatable>
                </div>
            </div>
        );
    }
}